import { Component, inject } from '@angular/core';

import { AppMaterialModule } from '../../material.module';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { ImageBoxComponent } from '../image-box/image-box.component';
import { _ImageBoxLinkComponent } from '../abstract-classes/_image-box-link.component';

@Component({
    selector: 'app-image-box-link',
    templateUrl: './image-box-link.component.html',
    standalone: true,
    host: {
        '[class.noclick]': 'noClick$$()',
    },
    imports: [
        ImageBoxComponent,
        AppMaterialModule,
    ],
    styleUrls: [
        '../image-box.scss',
        './image-box-link.component.scss']
})
export class ImageBoxLinkComponent
    extends _ImageBoxLinkComponent
{
    protected override _loadingPageService = inject(LoadingPageService);

    override border$$ = this.input_border$$;
    override guid$$ = this.input_guid$$;
    override guidPath$$ = this._guidPath$$;
    override hideOnLoading$$ = this.input_hideOnLoading$$;
    override loading$$ = this._loading$$;
    override noClick$$ = this.input_noClick$$;
    override size$$ = this.input_size$$;
    override tooltip$$ = this.input_tooltip$$;
    override tooltipPosition$$ = this.input_tooltipPosition$$;
    override url$$ = this.input_url$$;
    override version$$ = this.input_version$$;

    override emit_onClick(event: any): void {
        this._emit_onClick(event);
    }

}
